/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { MANAGEMENT_PAYMENT_STATUS, PAYMENT_TYPE } from '../../../constants/TaxPortal/MANAGEMENT_CONTACT_TYPE';
import { ControlTable } from '../../Table';
import useForm from '../../../hooks/useForm';
import { paymentChangeStatus, paymentList } from '../../../apis/tax-portal/billing';
import { getParams } from '../../../utils/params';
import Filters from '../../Filters';
import { cloneDeep } from 'lodash';
import { isEmpty } from '../../../utils/lodashExtend';
import PaymentStatusChange from './PaymentStatusChange';
import systemAlert from '../../../utils/systemAlert';
import { toast } from '../../../utils/toast';
import { isArray } from 'lodash';

const Payments = (props) => {
  const { idx } = props;

  const [filters] = useState([
    {
      title: "납부방식",
      type: "select",
      key: "search.type",
      options: {
        list: [{ label: "전체", value: "all" }, ...PAYMENT_TYPE],
      },
    },
    {
      title: "결제 상태",
      type: "select",
      key: "search.status",
      placeholder: "검색어 입력",
      options: {
        list: [{ label: "전체", value: "all" }, ...MANAGEMENT_PAYMENT_STATUS],
      },
    },
  ]);

  const [fields] = useState([
    {
      title: "납부방식",
      key: "type",
      onValue: (v) => PAYMENT_TYPE.find(f => f.value === v)?.label
    },
    {
      title: "금액",
      key: "price",
      type: "comma"
    },
    {
      title: "상태",
      key: "status",
      onValue: (v) =>
        <span className={`${v === "unPaid"
          ? "error"
          : v === "complate"
            ? "color-main-100"
            : ""}`}
        >
          {MANAGEMENT_PAYMENT_STATUS.find(f => f.value === v)?.label}
        </span>
    },
    {
      title: "납부일",
      key: "payDate",
      type: "date",
    },
  ]);

  const [detailOpen, setDetailOpen] = useState(false);

  const [tableButtons, setTableButtons] = useState([]);

  const {
    form,
    setSubmit,
    handleSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    filterSubmit,
    handleOnChange,
    selectedList, setSelectedList,
    reSubmit
  } = useForm(
    {
      page: 0,
      limit: 10,
      search: {
        billingIdx: idx
      },
      order: [{
        payDate: "desc"
      }]
    },
  );

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  useEffect(() => {
    setTableButtons([
      {
        label: "상태 변경",
        action: () => {
          setDetailOpen(true);
        },
        disabled: isEmpty(selectedList),
      }
    ]);
  }, [selectedList]);

  const submit = (form) => {
    const params = cloneDeep(form);
    if (params.search) {
      params.search.type === "all" && delete params.search.type;
      params.search.status === "all" && delete params.search.status;
    }
    paymentList(getParams(params))
      .then(res => {
        const { count, rows } = res;
        setList(rows);
        setTotal(count);
      })
      .finally(() => setIsLoading(false));
  };

  const _handleSubmit = (d) => {
    if (!isEmpty(d?.status) && !isEmpty(selectedList)) {
      systemAlert(`${selectedList.length}건의 결제항목의 상태를 변경하시겠습니까?`, {
        buttons: [
          {
            label: "취소",
            color: "text"
          },
          {
            label: "변경",
            onClick: () => {
              const body = {
                status: d.status,
                paymentIdx: selectedList.map(item => item.idx),
                billingIdx: idx,
                payDate: isArray(d.payDate) ? d.payDate[0] : d.payDate
              };
              paymentChangeStatus(body).then(res => {
                toast.success("변경이 완료되었습니다.");
                reSubmit();
              });
            }
          }
        ]
      });
    }
  };
  return (
    <>
      <Filters
        filters={filters}
        isLoading={isLoading}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isLoading={isLoading}
        list={list}
        fields={fields}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        submit={handleSubmit}
        isControl={true}
        selectedList={selectedList}
        setSelected={setSelectedList}
        buttons={tableButtons}
      />
      <PaymentStatusChange
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={_handleSubmit}
      />
    </>
  );
};

export default Payments;